import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { adminApi } from "@/lib/api";

const save = (id, k, value) => adminApi.setMarginCosts(id, { [k]: value });

export const CostInput = ({ row, k, onSaved }) => {
  const c = row.costs[k];
  const [v, setV] = useState(c.chf.toFixed(2));
  useEffect(() => setV(c.chf.toFixed(2)), [c.chf]);
  const commit = async () => {
    const n = Number(String(v).replace(",", "."));
    if (Number.isNaN(n) || n < 0) { toast.error("Importo non valido"); setV(c.chf.toFixed(2)); return; }
    if (Math.abs(n - c.chf) < 0.005) return;
    try { await save(row.id, k, n); toast.success("Costo salvato"); onSaved(); } catch { toast.error("Errore salvataggio"); }
  };
  const reset = async () => {
    try { await save(row.id, k, null); toast.success("Valore automatico ripristinato"); onSaved(); } catch { toast.error("Errore"); }
  };
  return (
    <div className="flex items-center gap-1">
      <input data-testid={`cost-${k}-${row.id}`} value={v} inputMode="decimal" onChange={(e) => setV(e.target.value)} onBlur={commit}
        onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
        className={`w-[78px] h-7 px-1.5 font-mono text-xs border rounded-sm bg-transparent focus:bg-white focus:outline-none focus:border-[#2B3036] transition-colors ${c.manual ? "border-[#2B3036] bg-white" : "border-transparent hover:border-[#d5dbde]"}`} />
      {c.manual ? (
        <button data-testid={`cost-reset-${k}-${row.id}`} onClick={reset} title={`Torna al valore automatico (CHF ${c.auto_chf.toFixed(2)})`}
          className="text-[#6b7280] hover:text-[#E0262C] transition-colors"><RotateCcw className="w-3 h-3" /></button>
      ) : (
        <span className="text-[9px] uppercase font-mono text-[#9ca3af]">{c.estimate ? "stima" : "auto"}</span>
      )}
    </div>
  );
};
